module.exports = __webpack_public_path__ + "static/media/nyj.8b9c5b80.png";